import { render, staticRenderFns } from "./search-modal.vue?vue&type=template&id=18b0cd28"
import script from "./search-modal.vue?vue&type=script&lang=js"
export * from "./search-modal.vue?vue&type=script&lang=js"
import style0 from "./search-modal.vue?vue&type=style&index=0&id=18b0cd28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/var/www/tubber-new/components/global/v/button.vue').default,BaseModal: require('/var/www/tubber-new/components/global/base-modal.vue').default})
